export enum ReportStatus {
  PENDING = 1,
  CANCELED = 2,
  APPROVED = 3,
  CORRECTION = 4,
  HELPING = 5,
  CONSOLIDATED_CLOSING_REPORT = 6
};

export const ChangeableReportStatuses = [
  ReportStatus.PENDING,
  ReportStatus.HELPING,
  ReportStatus.CORRECTION
] as const;

export enum ReportTypePeriodStatus {
  LOCKED = 1,
  ACTIVE = 2,
  INACTIVE = 3
}

export enum ReportPeriodTypeLabel {
  Active = 'active',
  Historic = 'historic'
};
